import { CurrencyPipe, NgClass } from '@angular/common';
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { ILiStyle1 } from '@core/interfaces/components/ul-style-1.interface';

@Component({
  selector: 'app-li-style-1',
  imports: [CurrencyPipe, NgClass],
  templateUrl: './li-style-1.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './li-style-1.css',
})
export class LiStyle1 {
  // datos
  item = input.required<ILiStyle1>();
  maximo_valor = input.required<number>();

  // metodos
  calcularPorcentaje = computed(() => {
    return (this.item().valor / this.maximo_valor()) * 100;
  });
}
